import { ProfileIconMenu as ProfileIconMenuWSC } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProfileIconMenu = observer(({ setDisplayContent }: Props) => {
  const ss = useStores().startupStore;
  const { t } = useTranslation();

  return ss.bearerTokenProfileInfo ? (
    <ProfileIconMenuWSC
      label={'Profile'}
      name={ss.bearerTokenProfileInfo.name}
      surname={ss.bearerTokenProfileInfo.surname}
      profilePhotoUrl={ss.profile?.profilePhotoUrl}
      accountUrl={ss.config?.accountManageUrl}
      logoutUrl={ss.config?.logoutUrl ? ss.config.logoutUrl + '?returnUrl=' + window.origin : undefined}
      supportUrl={ss.config?.supportUrl}
      userOrganization={ss.bearerTokenProfileInfo.organizationName}
      onMenuItemClick={(menuItemUrl) => {
        setDisplayContent(false);
        window.location.href = menuItemUrl;
      }}
      logoutLabel={t('logOut')}
      accountLabel={t('myProfile')}
      supportLabel={t('supportAndFAQ')}
    />
  ) : null;
});

export default ProfileIconMenu;
